import {Button, Card, Descriptions, Divider, Form, Input, notification, Tag, Typography} from "antd";

import {validateTrackingId} from "./validation";
import Api from "../../utilis/api/service";
import AuthContext from "../../utilis/contexts/AuthContext";
import React, {useContext, useState} from "react";
import {downloadBase64File} from "./helper";
const {Title}=Typography;
interface DataType {
    trace_number: string,
    key: string;
    name: string;
    mobile: string;
    national_code: string,
    company_national_code: string,
    company_name: string,
    user_type: "Individual" | "Company"
    father_name: string,
    address: string,
    birth_date: string,
    subject: string,
    created_at: string,
    attachment: string,
    answer_description: string | null,
    answer_attachment: string | null,
}

const TrackingForm = () => {
    const [form] = Form.useForm();
    const [loading,setLoading]=useState(false)
    const authContext=useContext(AuthContext);
    const [currentInfo,setCurrentInfo]=useState<DataType|null>(null)
    const handleSubmit = (value: any) => {
        setLoading(true);
        setCurrentInfo(null);

        Api.post('/TrackLetter',{
            TraceNumber:value.trackingId,
            Cellphone:authContext.user.cellphone,
        },{
            headers: {
                "Authorization": 'Bearer' + " " + authContext.Token.accessToken
            }
        }).then(response=>{
            if(response.data.Status===-1){
                notification.error({
                    message:response.data?.Message || '',
                    duration: 5,
                });
            }else {
                if(response?.data?.Data?.letters && response?.data?.Data?.letters.length>0)
                setCurrentInfo(response.data.Data.letters[0])
            }
        }).finally(()=>setLoading(false))
    }
    return <><Form   form={form}
                   initialValues={{
                      trackingId:'',

                   }} onFinish={handleSubmit} layout='vertical' className="flex flex-col">
        <Form.Item name="trackingId"
                   rules={[{required: true, message: 'شناسه درخواست را وارد کنید'},{
                       validator:validateTrackingId,
                   }]} label="شناسه درخواست">
            <Input size="large" placeholder="شناسه پیگیری را وارد کنید."/>
        </Form.Item>
        <Form.Item>
            <Button loading={loading} type="primary" htmlType="submit" size="large">جستجو</Button>
        </Form.Item>
    </Form>
        {currentInfo && <div className="grid bg-gray-50 p-2 grid-cols-1 gap-3">

            <Card>
                <Title level={4}> جزییات پاسخ  </Title>

                <Divider/>
                <Descriptions size="small" column={{
                    xs: 1,
                    sm: 1,
                    md: 2,
                    lg: 2,
                    xl: 2,
                    xxl: 2,
                }} bordered>
                    {currentInfo?.answer_description && <Descriptions.Item span={2} label="توضیحات پاسخ به درخواست شما">
                        <span className="text-sm">{currentInfo?.answer_description || '-'}</span>
                    </Descriptions.Item>}
                    {currentInfo?.answer_attachment && <Descriptions.Item span={2} label="فایل پاسخ به درخواست شما">
                        <Button
                            onClick={() => downloadBase64File(currentInfo?.answer_attachment || '', currentInfo?.trace_number+'_answer' || 'answer')}>دانلود
                            فایل </Button>
                    </Descriptions.Item>}

                </Descriptions>
            </Card>
        </div>}
    </>
}
export default TrackingForm;